import React from 'react'
import {SESSION_USER} from '../../constants';
import $ from 'jquery';
import  { compose, withProps, lifecycle } from 'recompose'
import {optimizeWayPoints} from '../../util/APIUtils';

import {withGoogleMap,withScriptjs, GoogleMap, DirectionsRenderer} from 'react-google-maps'
import { Modal } from 'react-bootstrap';
class GoogleMapPopup extends React.Component {
  constructor(props){
      super(props)
        this.state = {
            show: false,
            googleresponse:{},
            popuptext:''
        };

       this.handleSave = this.handleSave.bind(this);
       this.handleClose = this.handleClose.bind(this);
       this.handleOpen = this.handleOpen.bind(this);

  }

  handleClose(){
   this.setState({ show: false});
  }

  handleSave(){
        let user = JSON.parse(localStorage.getItem(SESSION_USER));

        
          const eventsReseponse=this.state.googleresponse;
          const googleMapInfo=this.props.mapresult;

          var routes= eventsReseponse.routes
          var waypoint_order= routes[0].waypoint_order;
          var legs= routes[0].legs;
           
          var fields={};
          fields['userId']=user.id
          fields['peopleId']=this.props.resourseId;
          fields['searchDate']=this.props.currentDate;
          fields['scheduleIds']=googleMapInfo.scheduleList
          fields['legs']=legs;
          fields['waypointOrder']=waypoint_order
          console.log("final",fields);

            optimizeWayPoints(fields)
                .then(response => {
                  console.log(response);
                  this.setState({ show: false});
                  this.props.isSuccessOptimize();
                }).catch(error => {
                if (error.status === 404) {
                    this.setState({
                        notFound: true,
                    });
                } else {
                    this.setState({
                        serverError: true,
                    });
                }
            });


    
  }

  handleOpen(googleresponse,popuptext){
      this.setState({ show: true,popuptext:popuptext,googleresponse:googleresponse});
  }

render() {
 
    const DirectionsComponent = compose(
      withProps({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyBPy3G7jB2iYJu9ccGeYuPBy-CVG6dKvks",
        loadingElement: <div style={{ height: `400px` }} />,
        containerElement: <div style={{ width: `100%` }} />,
        mapElement: <div style={{height: `550px`, width: `100%` }}  />,
      }),
      withScriptjs,
      withGoogleMap,
      lifecycle({
        componentDidMount() {
          let $this = this;

          const google = window.google
         var waypts = [];
          var geopoints=this.props.mapresult.geopoints;
          if(geopoints){
            for(var k in geopoints){
               var geopoint=geopoints[k];
               waypts.push({location:geopoint.address,stopover: true});
        
            }
            //console.log("geopoints",geopoints);
          }

          
         // waypts.push({location:'9333 Imperial Hwy, Downey, CA 90242, USA',stopover: true});
         // waypts.push({location:'1250 S Fair Oaks Ave,Pasadena,CA,91105',stopover: true});
         // waypts.push({location:'600 Atlantic Ave, Long Beach, CA 90813, USA',stopover: true});
          


          const peopleaddress=this.props.mapresult.peopleAddress;
          //alert(peopleaddress);
          const DirectionsService = new google.maps.DirectionsService();
         

          calculateAndDisplayRoute(peopleaddress,waypts,false);

   $("#optimizeroute").off('click').click(function () {
          calculateAndDisplayRoute(peopleaddress,waypts,true);

   });
        
        

        document.getElementById('mode').addEventListener('change', function() {
              calculateAndDisplayRoute(peopleaddress,waypts,false);
        });

                function calculateAndDisplayRoute(peopleaddress,waypts,isoptimize){
                   var selectedMode = document.getElementById('mode').value;
               
                    DirectionsService.route({
                         origin: peopleaddress,
                         destination:peopleaddress,
                         unitSystem: google.maps.UnitSystem.METRIC,
                         waypoints: waypts,
                         optimizeWaypoints: isoptimize,
                         travelMode: selectedMode,
                     }, (result, status) => {
                         if (status === google.maps.DirectionsStatus.OK) {
                            //console.log('result', result);
                             $this.setState({
                                 directions: {...result},
                                 markers: true
                             })
                             var popuptext='';
                             if(isoptimize){
                                   var route = result.routes[0]
                                   for (var i = 0; i < route.legs.length; i++) {
                                    var routeSegment = i + 1;
                                   
                                    
                                    popuptext += '<b>Route Segment: ' + routeSegment +'</b><br>';
                                    popuptext += "<b>From :</b> "+route.legs[i].start_address+ '<br>';
                                    popuptext += "<b>To :</b> "+route.legs[i].end_address + '<br>';
                                    popuptext += "<b>Distance :</b> "+route.legs[i].distance.text + '<br>';
                                    popuptext += "<b>Travel Duration :</b> "+route.legs[i].duration.text + '<br><br>';
                                  }

                                
                                //$this.props.popuptext=popuptext;
                                $this.props.show(result,popuptext);
                             }
                            
                             
                         } else {
                             console.error(`error fetching directions ${result}`);
                         }
                     });

                }
       
        }
      })
    )(props =>
      <GoogleMap
        defaultZoom={6}
        mapTypeId="roadmap"
        defaultCenter={{ lat: 34.1244631, lng: -118.1499428 }}
      >
        {props.directions && <DirectionsRenderer directions={props.directions} suppressMarkers={props.markers}/>}
      </GoogleMap>


    );
return (
<div>
        <DirectionsComponent mapresult={this.props.mapresult}  show={this.handleOpen}  popuptext={this.state.popuptext}/>
  
          <Modal show={this.state.show} onHide={this.handleClose}  dialogClassName="modal-90w" >
                              <Modal.Header closeButton>
                                <Modal.Title>Optimize Route</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>

                              
                                
  <div dangerouslySetInnerHTML={{__html: this.state.popuptext}}></div>

                              </Modal.Body>
                              <Modal.Footer>
                               


                                                        <input type="button" value="Optimize Scheduled Job"   onClick={this.handleSave} className="btn btn-rounded btn-primary agility-green"/>&nbsp;&nbsp;
                                                        <input type="button" onClick={this.handleClose} id="close" value="Close" className="btn btn-rounded btn-inverse"/>
                              </Modal.Footer>
                            </Modal>
</div>

    )
  }
}
export default GoogleMapPopup